import {InvoiceDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_EXPENSE';

export async function deleteInvoice(
    userData: Record<string, string>,
    invoiceId: number
) {
    try {
        const result = await InvoiceDao.deleteInvoice(userData.userToken, invoiceId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression d\'un facture',
            error: error
        });
    }
}
